module.exports = __webpack_public_path__ + "static/media/guarded.68eab711.jpg";